/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zoom_Percentage_ValueInputs */



/**
* | output |
* | --- |
* | "Zoom percentage value" |
*
* @param {Zoom_Percentage_ValueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom_percentage_value = /** @type {((inputs?: Zoom_Percentage_ValueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zoom_Percentage_ValueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Valeur du pourcentage de zoom")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zoom-Prozentwert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Valore percentuale dello zoom")
	if (locale === "ru") return /** @type {LocalizedString} */ ("значение процента масштабирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Valor porcentual de zoom")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("缩放百分比值")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ズーム率の値")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ज़ूम प्रतिशत मान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Valor percentual do zoom")
	return /** @type {LocalizedString} */ ("Zoom percentage value")
});